export const PAGE_WIDTH = 536
export const PAGE_HEIGHT = 758
